var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7443 0.923096C24.1256 0.923096 30.4706 7.41598 30.4706 14.8444C30.4706 23.4597 23.0336 28.8076 15.7148 28.8076C13.2948 28.8076 10.6093 28.1932 8.45492 26.9924C7.70238 26.5595 7.06788 26.2384 6.25631 26.4897L3.27564 27.3275C2.5231 27.5509 1.84433 26.9924 2.06567 26.2384L3.05431 23.1106C3.21662 22.6778 3.18711 22.217 2.95102 21.8539C1.68202 19.6477 0.958984 17.2321 0.958984 14.8863C0.958984 7.54165 7.17117 0.923096 15.7443 0.923096ZM22.4877 13.113C21.44 13.113 20.5989 13.9089 20.5989 14.9003C20.5989 15.8777 21.44 16.6875 22.4877 16.6875C23.5353 16.6875 24.3764 15.8777 24.3764 14.9003C24.3764 13.9089 23.5353 13.113 22.4877 13.113ZM15.6853 13.113C14.6524 13.099 13.7965 13.9089 13.7965 14.8863C13.7965 15.8777 14.6376 16.6736 15.6853 16.6875C16.7329 16.6875 17.574 15.8777 17.574 14.9003C17.574 13.9089 16.7329 13.113 15.6853 13.113ZM8.88284 13.113C7.83518 13.113 6.9941 13.9089 6.9941 14.9003C6.9941 15.8777 7.84994 16.6875 8.88284 16.6875C9.9305 16.6736 10.7716 15.8777 10.7716 14.9003C10.7716 13.9089 9.9305 13.113 8.88284 13.113Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBtn);
export default __webpack_public_path__ + "static/media/message_btn.12c3cd89762e13318ddb8d3a49884623.svg";
export { ForwardRef as ReactComponent };